import React from "react";
import { Link } from "react-router-dom";
import "../../Styles/Feefrequency.css";

export default function VehicleFineDetail1() {
  return (
    <div className="fee-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Vehicle Fine Details</h4>
        <div className="yc-header-actions">
          <Link to="/updatevehiclefine" className="btn btn-primary">Edit</Link>
          <button type="button" className="btn btn-danger">Delete</button>
        </div>
      </div>

      <div className="ff-page-body">
        <div className="card ff-detail-card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table ff-detail-table mb-0">
                <tbody>
                  <tr>
                    <td className="fw-bold ff-detail-label">Vehicle Name</td>
                    <td>New Vehicle</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Driver Name</td>
                    <td>Super Fast</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Reason</td>
                    <td>Over Speed</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Date</td>
                    <td>Thu Mar 3 2022</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Status</td>
                    <td>
                      <span className="yc-status yc-status--info">Active</span>
                    </td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Amount</td>
                    <td>$1000</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
